import { parseSearchString } from "@dafiti/core-layout";

const SEARCH_TERM_KEY = "searchTerm";

export function setSearchTerm(term: string): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(SEARCH_TERM_KEY, term);
  } catch {}
}

export function getSearchTerm(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return sessionStorage.getItem(SEARCH_TERM_KEY);
  } catch {
    return null;
  }
}

// Hyphens are kept on purpose: the URL preserves them, so `t-shirt` and
// `t shirt` are different searches.
function normalizeSearchTerm(term: string): string {
  let decoded = term;
  try {
    decoded = decodeURIComponent(term);
  } catch {}
  return decoded.replace(/\s+/g, " ").trim().toLowerCase();
}

function isSameSearchTerm(a: string, b: string): boolean {
  return normalizeSearchTerm(a) === normalizeSearchTerm(b);
}

/**
 * The path is the source of truth for the term; the stored one only refines
 * its spelling: the casing the URL lost on normalization, and the hyphens the
 * `parseSearchString` fallback below turns into spaces. It is used only when
 * it is the same term as the path: a leftover from a previous search would
 * otherwise override the navigation and list the wrong products.
 */
export function buildSearchPathForBff(catalogPath: string): string {
  if (!catalogPath.startsWith("/s/")) return catalogPath;

  const rawTerm = catalogPath.replace(/^\/s\//, "");

  const searchTerm = getSearchTerm();
  if (searchTerm && isSameSearchTerm(searchTerm, rawTerm)) {
    return `/s/${encodeURIComponent(searchTerm)}`;
  }

  const parsedTerm = parseSearchString(rawTerm);

  return parsedTerm ? `/s/${encodeURIComponent(parsedTerm)}` : catalogPath;
}
